import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Header from '@/components/Header'
import Index from '@/components/Index'
import ProductService from '@/components/ProductService'
import About from '@/components/About'
import Pay from '@/components/Pay'
import News from '@/components/News'
import NewsDetail from '@/components/NewsDetail'
import CooperationCase from '@/components/cooperationCase'
import test from '@/components/test'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/website/index'
    }, 
    {
        path: '/website',
        name: '基础数据',
        iconCls: 'fa fa-database',
        component: Header,
        children:[
            {
            hidden: true,
            path: '',
            redirect: to => {
                return 'index'
            }
            },
            { path: 'index', component: Index, name: '首页' },
            { path: 'product_service', component: ProductService, name: '产品服务' },
            { path: 'about', component: About, name: '关于我们' },
            { path: 'pay', component: Pay, name: '支付' },
            { path: 'news', component: News, name: '新闻' },
            { path: 'news_detail', component: NewsDetail, name: '新闻详情' },
            { path: 'cooperation_case', component: CooperationCase, name: '合作案例' },
            { path: 'test', component: test, name: '测试一下轮播图' },

            

        ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js